import { DateTime } from 'luxon';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { COLOR_LIGHT_GRID, FORMAT_TIME_DISPLAY } from '../const';
import { ComponentsDispatch, RootState } from '../store';
import { setterCalendar } from '../store/slices/calendarSlice';
import { ItemTaskType } from '../types';

interface IGantItemTask {
    subTask: ItemTaskType;
}

const GantItemTask: React.FC<IGantItemTask> = ({ subTask }) => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const currentTask = useSelector<RootState, ItemTaskType | null>((state) => state.calendar.currentTask);

    const startTime = DateTime.fromSQL(subTask.start_datetime!).toFormat(FORMAT_TIME_DISPLAY);
    const endTime = DateTime.fromSQL(subTask.end_datetime!).toFormat(FORMAT_TIME_DISPLAY);

    const onClickTask = () => {
        dispatch(
            setterCalendar({
                currentTask: null,
            }),
        );

        setTimeout(() => {
            dispatch(
                setterCalendar({
                    currentTask: subTask,
                }),
            );
        });
    };

    const backgroundColor = currentTask?.id === subTask.id ? COLOR_LIGHT_GRID : 'white';

    return (
        <div key={subTask.id} style={{ padding: '0 5px', backgroundColor }} onClick={onClickTask}>
            <p style={{ fontWeight: 'bold', margin: 0 }}>{subTask.name}</p>
            <p style={{ margin: 0 }}>{`${startTime}-${endTime}`}</p>
        </div>
    );
};

export default GantItemTask;
